module.exports = __webpack_public_path__ + "img/rightthigh-ectomorph-female.309e25da.svg";